export const environment = {
  production: true,
  apiURL: "https://api.test.yournotes.nl",
  baseURL: "https://test.yournotes.nl",
  name: "qa",
  editEventEnabled: true
};
